import { onAuthStateChanged } from "firebase/auth";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { auth, db } from "../../firebase/client";
import {
	resetBroadcast,
	setAwayLogo,
	setAwayTeam,
	setBroadcastId,
	setBroadcastUserId,
	setFixtureDate,
	setFixtureId,
	setFullTimeAt,
	setHalfTimeAt,
	setHomeLogo,
	setHomeTeam,
	setLocation,
	setSecondHalfStartTime,
	setStartTime,
	setVenue,
} from "../../redux/broadcast/broadcast.actions";
import { store } from "../../redux/store";

const AuthSync = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		return onAuthStateChanged(auth, async (user) => {
			const uid = user && !user.isAnonymous ? user.uid : null;
			if (!uid) return;

			const { broadcastId, broadcastUserId } = store.getState().broadcast;

			// Different user signed in — clear the stale session
			if (broadcastUserId && broadcastUserId !== uid) {
				dispatch(resetBroadcast());
			}

			// No active broadcast in Redux — check Firestore for one belonging to this user
			const currentId = store.getState().broadcast.broadcastId;
			if (!currentId) {
				const snap = await getDocs(
					query(
						collection(db, "broadcasts"),
						where("userId", "==", uid),
						where("status", "in", ["live", "upcoming"]),
					),
				);

				if (!snap.empty) {
					const doc = snap.docs[0];
					const d = doc.data();
					dispatch(setBroadcastId(doc.id));
					dispatch(setBroadcastUserId(uid));
					dispatch(setHomeTeam(d.homeTeam ?? ""));
					dispatch(setAwayTeam(d.awayTeam ?? ""));
					dispatch(setHomeLogo(d.homeLogo ?? ""));
					dispatch(setAwayLogo(d.awayLogo ?? ""));
					dispatch(setVenue(d.venue ?? ""));
					dispatch(setLocation(d.location ?? ""));
					dispatch(setFixtureDate(d.fixtureDate ?? ""));
					if (d.fixtureId) dispatch(setFixtureId(d.fixtureId));
					if (d.startTime) dispatch(setStartTime(d.startTime));
					if (d.halfTimeAt) dispatch(setHalfTimeAt(d.halfTimeAt));
					if (d.secondHalfStartTime) dispatch(setSecondHalfStartTime(d.secondHalfStartTime));
					if (d.fullTimeAt) dispatch(setFullTimeAt(d.fullTimeAt));
				}
			}
		});
	}, [dispatch]);

	return null;
};

export default AuthSync;
